var _a;
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { MaterialParametrs } from '@api-gen';
import { PointConnectionsFieldsType, ThicknessDensityFieldsType, WidthRacksStepFieldsType, } from '@features/guidbooks/presentation';
import { MaterialTypeEnum } from '@features/guidbooks/types';
export var ConstructionFieldsMap = function (_a) {
    var _b;
    var materialType = _a.materialType, fieldIndex = _a.fieldIndex, constructionIndex = _a.constructionIndex, currentForm = _a.currentForm;
    var componentsMap = (_b = {},
        _b[MaterialTypeEnum.Heavy] = (_jsx(ThicknessDensityFieldsType, { fieldIndex: fieldIndex, constructionIndex: constructionIndex, currentForm: currentForm })),
        _b[MaterialTypeEnum.AirGap] = (_jsx(ThicknessDensityFieldsType, { fieldIndex: fieldIndex, constructionIndex: constructionIndex, currentForm: currentForm })),
        _b[MaterialTypeEnum.Link] = (_jsx(PointConnectionsFieldsType, { fieldIndex: fieldIndex, constructionIndex: constructionIndex, currentForm: currentForm })),
        _b[MaterialTypeEnum.Frame] = (_jsx(WidthRacksStepFieldsType, { fieldIndex: fieldIndex, constructionIndex: constructionIndex, currentForm: currentForm })),
        _b[MaterialTypeEnum.Filler] = (_jsx(ThicknessDensityFieldsType, { fieldIndex: fieldIndex, constructionIndex: constructionIndex, currentForm: currentForm })),
        _b[MaterialTypeEnum.Board] = (_jsx(ThicknessDensityFieldsType, { fieldIndex: fieldIndex, constructionIndex: constructionIndex, currentForm: currentForm })),
        _b[MaterialTypeEnum.AcousticTreatmentMaterials] = (_jsx(ThicknessDensityFieldsType, { fieldIndex: fieldIndex, constructionIndex: constructionIndex, currentForm: currentForm })),
        _b[MaterialTypeEnum.Membrane] = (_jsx(ThicknessDensityFieldsType, { fieldIndex: fieldIndex, constructionIndex: constructionIndex, currentForm: currentForm })),
        _b[MaterialTypeEnum.ZPanel] = (_jsx(ThicknessDensityFieldsType, { fieldIndex: fieldIndex, constructionIndex: constructionIndex, currentForm: currentForm })),
        _b[MaterialTypeEnum.FoamMaterials] = _jsx(_Fragment, {}),
        _b[MaterialTypeEnum.Glazing] = _jsx(_Fragment, {}),
        _b[MaterialTypeEnum.GypsumBondedbBoards] = _jsx(_Fragment, {}),
        _b[MaterialTypeEnum.WoodBasedBoard] = _jsx(_Fragment, {}),
        _b[MaterialTypeEnum.Metal] = _jsx(_Fragment, {}),
        _b[MaterialTypeEnum.MasonryAndSolid] = _jsx(_Fragment, {}),
        _b[MaterialTypeEnum.PorousMaterials] = _jsx(_Fragment, {}),
        _b[MaterialTypeEnum.SandwichPanel] = _jsx(_Fragment, {}),
        _b[MaterialTypeEnum.MineralBondedBoards] = _jsx(_Fragment, {}),
        _b);
    return componentsMap[materialType] || _jsx(_Fragment, {});
};
export var MaterialTypeValuesMap = (_a = {},
    _a[MaterialTypeEnum.Heavy] = [
        {
            materialParameters: MaterialParametrs.Thickness,
            value: '',
        },
        {
            materialParameters: MaterialParametrs.Density,
            value: '',
        },
    ],
    _a[MaterialTypeEnum.AirGap] = [
        {
            materialParameters: MaterialParametrs.Thickness,
            value: '',
        },
        {
            materialParameters: MaterialParametrs.Density,
            value: '',
        },
    ],
    _a[MaterialTypeEnum.Link] = [
        {
            materialParameters: MaterialParametrs.ConnectionNumber,
            value: '',
        },
    ],
    _a[MaterialTypeEnum.Frame] = [
        {
            materialParameters: MaterialParametrs.Width,
            value: '',
        },
        {
            materialParameters: MaterialParametrs.RackStep,
            value: '',
        },
    ],
    _a[MaterialTypeEnum.Filler] = [
        {
            materialParameters: MaterialParametrs.Thickness,
            value: '',
        },
        {
            materialParameters: MaterialParametrs.Density,
            value: '',
        },
    ],
    _a[MaterialTypeEnum.Board] = [
        {
            materialParameters: MaterialParametrs.Thickness,
            value: '',
        },
        {
            materialParameters: MaterialParametrs.Density,
            value: '',
        },
    ],
    _a[MaterialTypeEnum.AcousticTreatmentMaterials] = [
        {
            materialParameters: MaterialParametrs.Thickness,
            value: '',
        },
        {
            materialParameters: MaterialParametrs.Density,
            value: '',
        },
    ],
    _a[MaterialTypeEnum.Membrane] = [
        {
            materialParameters: MaterialParametrs.Thickness,
            value: '',
        },
        {
            materialParameters: MaterialParametrs.Density,
            value: '',
        },
    ],
    _a[MaterialTypeEnum.ZPanel] = [
        {
            materialParameters: MaterialParametrs.Thickness,
            value: '',
        },
        {
            materialParameters: MaterialParametrs.Density,
            value: '',
        },
    ],
    _a[MaterialTypeEnum.FoamMaterials] = [],
    _a[MaterialTypeEnum.Glazing] = [],
    _a[MaterialTypeEnum.GypsumBondedbBoards] = [],
    _a[MaterialTypeEnum.WoodBasedBoard] = [],
    _a[MaterialTypeEnum.Metal] = [],
    _a[MaterialTypeEnum.MasonryAndSolid] = [],
    _a[MaterialTypeEnum.PorousMaterials] = [],
    _a[MaterialTypeEnum.SandwichPanel] = [],
    _a[MaterialTypeEnum.MineralBondedBoards] = [],
    _a);
